import { FunnelConfig } from '~/utils/funnels';
import { store } from '~/utils/store';

export const config: FunnelConfig = {
  id: 'welcomeBack',
  path: '/welcome-back',
  show: () => !!store.get('TOKEN'),
};
